import { Button, Typography, Container, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { styled } from '@mui/material/styles';

const StyledContainer = styled(Container)(({ theme }) => ({
  minHeight: '75vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  padding: theme.spacing(3),
}));

function PageNotFound(){
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/softwares');
  };

  return (
    <StyledContainer maxWidth="sm">
      <ErrorOutlineIcon 
        sx={{ 
          fontSize: 80, 
          color: 'error.main', 
          mb: 2 
        }} 
      />
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom
        color="text.primary"
      >
        404 - Page Not Found
      </Typography>
      <Typography 
        variant="body1" 
        color="text.secondary" 
        paragraph
      >
        Oops! It seems like the page you're looking for doesn't exist or has been moved.
      </Typography>
      <Box mt={4}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleGoBack}
        >
          Back to Home
        </Button>
      </Box>
    </StyledContainer>
  );
};

export default PageNotFound;